export default __webpack_public_path__ + "static/Friends for Disability_logo-b6da322c447c2c471aabe5ebf119c020.png";